module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-3-1-fc0ac6bea6eea4d7584e3ac12b393712.png";